import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { SearchService } from '../../shared/services/search.service';
import { Content } from '../../core/content/content';
import { EntityService } from '../../shared/services/entity.service';
import { ArticleImSearchService } from '../../shared/services/article-im-search.service';
import { Subscription } from 'rxjs';
import { PublicationSource } from '../search/publication-source';
import { first } from 'rxjs/operators';
import { LoaderService } from '../../common-explain/services/loader.service';
import { ApiService } from '../../shared/services/api/api.service';
import { SmartSearchService } from '../../shared/services/smart-search.service';
import { FeatureModalSmartSearchComponent } from '../feature-modal-smart-search/feature-modal-smart-search.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-admin-docs-page',
  templateUrl: './admin-docs-page.component.html',
  styleUrls: ['./admin-docs-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AdminDocsPageComponent extends Content implements OnInit, OnDestroy {
  @ViewChild('panel', { read: ElementRef }) panel!: ElementRef;
  nbTotalAdminDoc!: number;
  nbTotalWebsite!: number;
  adminDocsCount!: number;
  websitesCount!: number;
  docId: string | null = null;

  /** Subscriptions to services */
  getEntityIdSubscription!: Subscription;
  entityServiceSubscription!: Subscription;

  constructor(
    protected override searchService: SearchService,
    protected override entityService: EntityService,
    protected override articleImSearchService: ArticleImSearchService,
    private apiService: ApiService,
    private loaderService: LoaderService,
    protected smartSearchService: SmartSearchService,
    protected modalService: NgbModal
  ) {
    super(searchService, entityService, articleImSearchService);
  }

  ngOnInit() {
    this.apiService.exStatistics.ExplainStatisticsReplaySubject.pipe(first()).subscribe(stats => {
      this.nbTotalAdminDoc = stats.allAdminDocsCount;
      this.nbTotalWebsite = stats.allWebsitesCount;
    });

    this.getEntityIdSubscription = this.entityService.getEntityId().subscribe(docId => {
      this.docId = docId;
    });

    this.searchService.sentPageIndex(1);
    this.getSearch();

    this.entityServiceSubscription = this.entityService.BookMarkPathsSubject.subscribe(({ id, bookmarkPaths }) => {
      if (this.entities) {
        const updatedBookmarkPathsIndex = this.entities.findIndex(obj => obj['id'] === id);
        this.entities[updatedBookmarkPathsIndex]['bookmark_paths'] = bookmarkPaths;
      }
    });
  }

  ngOnDestroy() {
    /** Unsubscribe of the unherited searchSubscription from Content */
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }

    /** Unsubscribe of subscriptions */
    if (this.getEntityIdSubscription) {
      this.getEntityIdSubscription.unsubscribe();
    }

    if (this.entityServiceSubscription) {
      this.entityServiceSubscription.unsubscribe();
    }

    this.searchService.currentPage = 1;
  }

  /** Overriding abstact method retrieveData declared in Content */
  retrieveData(search: any): void {
    this.websitesCount = search['filters']['resources_count'];
    const body = this.buildBody(search);

    this.request(
      this.apiService.adminDoc
        .retrieveAdminDocs(body, this.searchService.SearchModeMap.get(PublicationSource.ADMIN_DOCS))
        .pipe(first())
        .subscribe(
          (data: any) => {
            this.panel.nativeElement?.querySelector('.content-list')?.scrollTo({ top: 0, behavior: 'smooth' });
            const bodyCount = this.buildCountBody(search);
            this.apiService.adminDoc
              .retrieveAdminDocsCount(bodyCount)
              .pipe(first())
              .subscribe((adminDocCountData: any) => {
                this.setEntities(data, search['limit'], search['offset']);
                this.entities.forEach((item: any) => {
                  setRedirectsToUrl(item);
                });
                this.adminDocsCount = adminDocCountData['count'];
              });
          },
          _ => {
            this.totalCount = 0;
            this.loaderService.hideLoader(true);
          }
        )
    );
  }

  openSmartSearchIntro() {
    this.modalService.open(FeatureModalSmartSearchComponent, { centered: true, windowClass: 'modal-auto' });
  }
}

export function setRedirectsToUrl(entity: any) {
  entity['redirects_to_url'] = entity['source'] === 'PREF' && entity['publication_type'][0] === 'avis_enquete_publique';
}
